module.exports = __webpack_public_path__ + "assets/images/CNY100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CNY100.png
// module id = 1344
// module chunks = 1